import React, { FC, useEffect, useState } from 'react';
import { Button, ButtonStyles, MultilineInput, Popup } from '@silverfort/sf-components';

interface Props {
    open: boolean;
    policyName: string;
    onClose: () => void;
    onSaveAsTemplate: (description: string) => void;
}

interface ContentProps {
    policyName: string;
    description: string;
    onDescriptionChange: (description: string) => void;
}

interface FooterProps {
    saveDisabled?: boolean;
    onCancelClick: () => void;
    onSave: () => void;
}

const Content: FC<ContentProps> = ({ policyName, description, onDescriptionChange }) => (
    <div className="flex flex-col gap-4">
        <span className="font-sf text-13 leading-[19px] tracking-[0.0156rem]">
            In order to save{' '}
            <span className="font-sf text-13 leading-[19px] tracking-[0.0156rem] font-medium">{policyName}</span> as a
            template, you are required to add a description.
        </span>
        <MultilineInput
            className="w-full py-2 px-3 placeholder:text-sf-gray-400 leading-[19px] tracking-[0.0156rem]"
            placeholder="Write description"
            value={description}
            onChange={onDescriptionChange}
        />
    </div>
);

const Footer: FC<FooterProps> = ({ saveDisabled = false, onCancelClick, onSave }) => (
    <div className="gap-4 flex justify-end items-center">
        <Button buttonStyle={ButtonStyles.GhostSolid} text="Cancel" onClick={onCancelClick} />
        <Button disabled={saveDisabled} text="Save template" onClick={onSave} />
    </div>
);

const SaveAsTemplateModal: FC<Props> = ({ open, policyName, onClose, onSaveAsTemplate }) => {
    const [description, setDescription] = useState('');

    useEffect(() => {
        if (!open) {
            setDescription('');
        }
    }, [open]);

    return (
        <Popup
            open={open}
            popupClassName="w-[360px]"
            title="Template Description"
            onClose={onClose}
            ContentComponent={Content}
            ContentComponentProps={{ policyName, description, onDescriptionChange: setDescription }}
            FooterComponent={Footer}
            FooterComponentProps={{
                onCancelClick: onClose,
                saveDisabled: !description,
                onSave: () => onSaveAsTemplate(description)
            }}
        />
    );
};

export default SaveAsTemplateModal;
